import { useCan } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";

import type { DealerLocation } from "models";

export const useCanConvertToIntervention = (location: DealerLocation | undefined, isAlreadyConverted: boolean) => {
  const canAddIntervention = useCan(ACL_ACTIVITIES.Create, ACL_RESOURCES.Interventions);

  return canAddIntervention && !isAlreadyConverted && location?.convert_checklist_to_intervention_is_enabled;
};
